/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { makeStyles } from 'tss-react/mui';
import { Palette, Tokens } from '@jda/lui-common-component-library-mui5';

export const useStyles = makeStyles()(theme => ({
  root: {
    margin: theme.spacing(0, 2),
    background: 'transparent !important',
    position: "relative",
    overflow: "hidden",
  },
  card: {
    '& .MuiCardContent-root:last-child': {
      paddingBottom: 0,
    }
  },
  appBarWrap: {
    display: "flex",
    flexDirection: "row",
    background: 'transparent !important',
  },
  backIcon: {
    width: Tokens.spacing['$sp-12'],
    height: Tokens.spacing['$sp-12'],
    color: theme.palette.text.primary,
  },
  headingAlignment: {
    color: theme.palette.text.primary,
    fontSize: Tokens.spacing['$sp-8-5'],
    marginBottom: Tokens.spacing['$sp-4']
  },
  tabBoxMain: {
    display: "flex",
    flexDirection: "column",
    
  },
  tabs: {
    borderBottomStyle: 'none',
    width: Tokens.spacing['$sp-51-5'],
    padding: Tokens.spacing['$sp-3'],
    backgroundColor: theme.palette.mode === 'light' ? Palette.FractalUI.light.steel[2] : Palette.FractalUI.dark.steel[2],
    '& :last-child': {
    paddingBottom: 0,
    }
  },
  tabTextStyle: {
    alignItems: 'flex-start',
    marginLeft: Tokens.spacing['$sp-2'],
  },
}));

